<template>
  <div>
    <Progress />
    <h1 class="text-center mt-10">{{ $t('pageDateTime.header') }}</h1>
    <p class="text-center mt-5">{{ $t('pageDateTime.subHeader1') }}</p>
    <v-container>
      <v-row no-gutters>
        <div class="col-12 col-md-6 pr-md-6">
          <DatePicker v-on:childToParent="dateChange" />
        </div>
        <div class="col-12 col-md-6 pl-md-6">
          <AppointmentTypePicker
            v-on:childToParent="optionsChange"
            :key="user.datetime.date"
            :options="this.user.lists.optiondto"
            :currentSelected="currentSelected"
          />
          <div v-if="this.user.errors.optiondto">
            <p>{{ this.user.errors.optiondto.error }}</p>
          </div>
        </div>
      </v-row>
      <v-row no-gutters v-if="this.timeResultsArrival && this.timeResultsArrival.length > 0 && this.user.datetime.option !== ''">
        <div class="col-12 col-md-6 d-flex" v-if="this.timeResultsArrival.length > 0">
          <TimePicker
            :title="'pageDateTime.subHeader4'"
            :times="this.timeResultsArrival"
            :name="'arrival'"
            v-on:timeSelected="timeChangeArrival"
            class="mr-md-6 mt-md-12 mt-6"
          />
        </div>
        <div class="col-sm-12 col-md-6 d-flex" v-if="pickUpTimeIsVisible">
          <TimePicker
            :title="'pageDateTime.subHeader5'"
            :times="this.timeResultsPickup"
            :name="'pickup'"
            v-on:timeSelected="timeChangePickup"
            class="ml-md-6 mt-md-12 mt-6"
          />
        </div>
        <div fill-height class="mr-md-6 mt-md-12 mt-6 pl-md-6" v-if="this.user.specialProperties.pickuptimeOverwrite != ''">
          <p>{{ this.user.specialProperties.pickuptimeOverwrite }}</p>
        </div>
        <div
          fill-height
          class="pickuptimeOverwrite mr-md-6 mt-md-12 mt-6 pl-md-6"
          v-if="
            this.user.specialProperties.pickuptimeOverwrite === '' &&
            this.timeResultsPickup.length === 0 &&
            this.user.datetime.option.alias === '1000'
          "
        >
          <p>{{ $t('validation.specific.pickupTimeContact') }}</p>
        </div>
      </v-row>
      <v-row no-gutters v-if="!availableTimesExist">
        <div class="col-12 col-md-12 pt-13 pb-4 pl-6">{{ $t('validation.specific.noFreeTimes') }}</div>
      </v-row>
      <v-row no-gutters class="mt-4">
        <div class="col-6 pt-10">
          <ProgressButton
            :label="{ text: this.text.buttonBack, alias: 'Appointment-button--back', page: 'appointment', action: 'previous' }"
            :step="{ number: 0 }"
          />
        </div>
        <div class="col-6 pt-10">
          <div class="float-right">
            <ProgressButton
              :label="{ text: this.text.buttonNext, alias: 'Appointment-button--next', page: 'appointment', action: 'next' }"
              :step="{ number: 2 }"
            />
          </div>
        </div>
      </v-row>
    </v-container>
    <Loader v-if="this.user.loading" />
  </div>
</template>

<script>
import localizationTexts from '@/localization/texts.json';
import Progress from '@/components/Progress.vue';
import AppointmentTypePicker from '@/components/AppointmentTypePicker.vue';
import Loader from '@/components/Loader.vue';
import ProgressButton from '@/components/ProgressButton.vue';
import DatePicker from '@/components/DatePicker.vue';
import TimePicker from '@/components/TimePicker.vue';
import helpers from '@/settings/helpers';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'Appointment',
  components: {
    Progress,
    AppointmentTypePicker,
    DatePicker,
    TimePicker,
    Loader,
    ProgressButton
  },
  data() {
    return {
      text: {
        buttonBack: '',
        buttonNext: ''
      },
      timeResultsArrival: [],
      timeResultsPickup: [],
      availableTimesExist: true,
      currentSelected: 0,
      loading: true
    };
  },
  methods: {
    dateChange(payload) {
      const dataLayerData = {
        event: 'easybooking-click',
        eventCategory: 'appointment',
        eventAction: 'appointment-date',
        appointmentDate: payload
      };
      helpers.sendGTM(dataLayerData, this.user.config.host);
      this.availableTimesExist = true;

      // try find date in state.user.lists.optionsDatesMappings
      if (this.user.lists.optionsDatesMappings.length > 0) {
        var datesMapping = this.user.lists.optionsDatesMappings.find((x) => x.date == payload);
        if (datesMapping) {
          this.$store.dispatch('user/setOptionsDatesMappings', datesMapping);
        }
      } else {
        this.$store.dispatch('user/initLoading', true);

        this.$store.dispatch('user/initDateDate', payload).then(() => {
          const servicesTime = this.user.servicesTime.hours * 60 + this.user.servicesTime.minutes;
          let optionsPayload = {
            endpoint: this.user.config.parameters.api + '/maintenance/timesandoptions',
            params: {
              token: this.user.token,
              traceid: this.user.guid,
              rooftopid: this.user.selectedRooftopid,
              culture: this.user.config.parameters.parameters.culture,
              makecode: this.user.car.makecode,
              modelcode: this.user.car.modelcode,
              variantcode: this.user.car.variantcode,
              services: this.user.selectedservices,
              jobdates: [this.user.datetime.date],
              registrationplate: this.user.registrationplate,
              totalserviceduration: servicesTime,
              times: [],
              disablewaitingoption: this.user.config.parameters.parameters.disablewaitingoption,
              enablerental: this.user.config.parameters.parameters.enablerental
            }
          };

          if (this.user.config.parameters.parameters.times) {
            optionsPayload.params.times.push({
              id: 1000,
              list: JSON.parse(this.user.config.parameters.parameters.times.replace(/'/g, '"')),
              replace: this.user.config.parameters.parameters.timesreplace ? this.user.config.parameters.parameters.timesreplace : false
            });
          }
          if (this.user.config.parameters.parameters.timesrental) {
            optionsPayload.params.times.push({
              id: 1001,
              list: JSON.parse(this.user.config.parameters.parameters.timesrental.replace(/'/g, '"')),
              replace: this.user.config.parameters.parameters.timesreplacerental ? this.user.config.parameters.parameters.timesreplacerental : false
            });
          }
          if (this.user.config.parameters.parameters.timeswaiting) {
            optionsPayload.params.times.push({
              id: 1002,
              list: JSON.parse(this.user.config.parameters.parameters.timeswaiting.replace(/'/g, '"')),
              replace: this.user.config.parameters.parameters.timesreplacewaiting ? this.user.config.parameters.parameters.timesreplacewaiting : false
            });
          }
          if (this.user.config.parameters.parameters.timesrentlogrental) {
            optionsPayload.params.times.push({
              id: 1100,
              list: JSON.parse(this.user.config.parameters.parameters.timesrentlogrental.replace(/'/g, '"')),
              replace: this.user.config.parameters.parameters.timesreplacerentlog ? this.user.config.parameters.parameters.timesreplacerentlog : false
            });
          }

          this.$store
            .dispatch('user/initListOptions', optionsPayload)
            .then(() => {
              this.$store.dispatch('user/initLoading', false);
            })
            .catch(() => {
              this.$store.dispatch('user/errorOptions');
              this.$store.dispatch('user/initLoading', false);
            });
        });
      }
    },
    optionsChange(optionToSet, index) {
      let moddedOptionToSet = optionToSet;
      moddedOptionToSet.checked = true;

      const dataLayerData = {
        event: 'easybooking-click',
        eventCategory: 'appointment',
        eventAction: 'appointment-option',
        appointmentOptionTitle: moddedOptionToSet.title,
        appointmentOptionRental: moddedOptionToSet.rental,
        appointmentOptionWaiting: moddedOptionToSet.pickup
      };
      helpers.sendGTM(dataLayerData, this.user.config.host);

      this.availableTimesExist = true;
      this.$store.dispatch('user/initDateOption', moddedOptionToSet);

      if (this.user.lists.optiondto.length > 0) {
        let localAlias = this.user.datetime.option.alias;
        var option;

        //Find the selected option
        if (typeof index === 'undefined') {
          option = this.user.lists.optiondto.find((item) => {
            return item.optionid === localAlias;
          });
        } else {
          this.currentSelected = index;
          option = this.user.lists.optiondto[index];
          this.user.datetime.option.alias = this.user.lists.optiondto[index].optionid;
        }

        //Check if there is any available times
        this.availableTimesExist = option?.dropofftimes?.length > 0;

        //Reset 'checked' and 'enabled' and add them to 'timeResultsArrival' and 'timeResultsPickup' respectively
        option.dropofftimes?.forEach((item) => {
          item.checked = false;
          item.enabled = true;
          const minutes = Number.parseInt(item.minutes)
          const formattedMinutes = 0 <= minutes && minutes <= 9 ? '0' + minutes : item.minutes;
          item.text = item.hours + ':' + formattedMinutes;
        });
        this.timeResultsArrival = option.dropofftimes;

        option.pickuptimes?.forEach((item) => {
          item.checked = false;
          item.enabled = true;
          const minutes = Number.parseInt(item.minutes)
          const formattedMinutes = 0 <= minutes && minutes <= 9 ? '0' + minutes : item.minutes;
          item.text = item.hours + ':' + formattedMinutes;
        });
        this.timeResultsPickup = option.pickuptimes;
      }
    },
    timeChangeArrival(arrivalToSet, id) {
      const dataLayerData = {
        event: 'easybooking-click',
        eventCategory: 'appointment',
        eventAction: 'appointment-time-arrival',
        appointmentTimeArrival: arrivalToSet.text
      };
      helpers.sendGTM(dataLayerData, this.user.config.host);

      this.$store.dispatch('user/setDateTimeArrival', arrivalToSet);

      let modTimeResultsArrival = JSON.parse(JSON.stringify(this.timeResultsArrival));
      modTimeResultsArrival?.forEach((time, index) => {
        if (index == id) {
          // enable / disable logic
          if (time.checked) {
            time.checked = false;
            this.$store.dispatch('user/setDateTimeArrival', '');
          } else {
            time.checked = true;
            this.$store.dispatch('user/setDateTimeArrival', arrivalToSet);
          }

          // always enable onclick element, never disable logic
          // time.checked = true;
        } else {
          time.checked = false;
        }
      });
      this.timeResultsArrival = modTimeResultsArrival;

      // find selected Pickup time, if any
      // const selectedIndex = this.timeResultsPickup.findIndex((time) => time.checked);

      //Check all service has jobtime
      const allHasTimes = !this.user.services.some((service) => !service.jobtime);
      if (allHasTimes) {
        if (this.user.specialProperties.pickuptimeOverwrite == '') {
          let modPickupTimes = JSON.parse(JSON.stringify(this.timeResultsPickup));

          modPickupTimes.forEach((item, index) => {
            if (index <= id && item.checked) {
              item.checked = false;
              item.enabled = false;
              this.$store.dispatch('user/setDateTimePickup', '');
            } else {
              if (index < id) {
                item.enabled = false;
              } else {
                item.enabled = true;
              }
            }
          });
          this.timeResultsPickup = modPickupTimes;
        }
      } else {
        // do stuff for when an item has no times available
        alert('Error: no times available');
      }
    },
    timeChangePickup(pickupToSet, id) {
      const dataLayerData = {
        event: 'easybooking-click',
        eventCategory: 'appointment',
        eventAction: 'appointment-time-pickup',
        appointmentTimePickup: pickupToSet.text
      };
      helpers.sendGTM(dataLayerData, this.user.config.host);

      let modtimeResultsPickup = JSON.parse(JSON.stringify(this.timeResultsPickup));
      modtimeResultsPickup?.forEach((time, index) => {
        if (index == id) {
          // enable / disable logic
          if (time.checked) {
            time.checked = false;
            this.$store.dispatch('user/setDateTimePickup', '');
          } else {
            time.checked = true;
            this.$store.dispatch('user/setDateTimePickup', pickupToSet);
          }

          // always enable onclick element, never disable logic
          // time.checked = true;
        } else {
          time.checked = false;
        }
      });
      this.timeResultsPickup = modtimeResultsPickup;

      // we no longer need this garbage hack, i think
      // this.$forceUpdate(); //$forceUpdate here as progressButton does not update otherwise. ProgressButton needs refactor anyways and this should be removable after
    }
  },
  computed: {
    ...mapGetters(['user']),
    pickUpTimeIsVisible() {
      return this.user.specialProperties.pickuptimeOverwrite == '' && this.timeResultsPickup.length > 0;
    }
  },
  beforeMount() {
    if (
      this.user.kilometers > 0 &&
      this.user.car.registrationplate !== undefined &&
      this.user.department.departmentid !== undefined &&
      this.user.services.length > 0
    ) {
      this.$store.dispatch('user/initStep', 2);
    } else if (this.user.step === 0) {
      this.$router.push({ name: 'Home' });
    } else if (this.user.step === 1) {
      this.$router.push({ name: 'Service' });
    } else if (this.user.step === 2) {
      this.$router.push({ name: 'Appointment' });
    } else if (this.user.step === 3) {
      this.$router.push({ name: 'Customer' });
    }
  },
  mounted() {
    helpers.sendScroll(this.user.config.container, 0, this.user.config.host);
    this.text.buttonBack = localizationTexts[this.user.config.language].button.back;
    this.text.buttonNext = localizationTexts[this.user.config.language].button.next;
  }
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
